import React, { useState, useEffect } from "react";
import { Button, Card, Container, Dropdown } from "react-bootstrap";
import "./integrationPage.scss";
import { IntegrationIcon } from "../../../asset/json/CardDetail";
import "../../common/tooltip.css";
import { LinkContainer } from "react-router-bootstrap";
import { Fade, Zoom, Slide, Bounce } from "react-reveal";
import Reveal from "react-reveal/Reveal";
import Background from "../../../asset/image/backgroundImage.svg";
import { Helmet } from "react-helmet";

const IntegrationPage = () => {
  const [data, setdata] = useState(false);
  const opencard = () => {
    setdata(true);
  };
  const closecard = () => {
    setdata(false);
  };
  return (
    <div>
      <Helmet>
        <meta
          charSet="utf-8"
          name="Cloudsocial : All social integration in your pocket"
        />
        <meta
          name="description"
          content="Cloudsocial offers you all social media integration for your all social media management needs. Checkout our page to know more"
        />
        <title>Social Media Integration apps| CloudSocial</title>
        <link rel="canonical" href="https://cloudsocial.io/integration" />
      </Helmet>
      <Container
        fluid
        style={{
          background: "#F5FBFF ",
          //  border: "none",
          backgroundImage: `url(${Background})`,
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="card-media">
          <Zoom top>
            <h1 className="media-title mt-3">Integrations</h1>
          </Zoom>
          <Zoom cascade>
            <h2 className="media-subtitle">
              CloudSocial has integrated all of your favourite apps for an
              holistic experience.
            </h2>
          </Zoom>

          <hr className="divider" />

          <Container fluid className="media-container">
            {IntegrationIcon.map(({ img, title, id, alt, content }) => (
              <Zoom cascade>
                <Card className="socialIconCard" key={id}>
                  <Card.Body className="iconBody">
                    <Card.Img
                      className="sIcon"
                      variant="top"
                      src={img}
                      alt={alt}
                    />
                    <Card.Subtitle className="social-title">
                      {title}
                    </Card.Subtitle>
                    <Card.Subtitle className="media-subtitle">
                      {content}
                    </Card.Subtitle>
                  </Card.Body>
                </Card>
              </Zoom>
            ))}
          </Container>

          <hr className="mt-5" style={{ width: "90%" }} />
        </div>
      </Container>
    </div>
  );
};
export default IntegrationPage;
